import clsx from 'classnames'
import * as React from 'react'

export interface ToolbarTextProps {
  className?: string
  selected?: boolean
  label: string
}

const ToolbarText = ({ selected, label, className, ...other }: ToolbarTextProps) => {
  return (
    <span
      className={clsx('MuiTypography-subtitle1 MuiPickersToolbarText-toolbarTxt', className, {
        'MuiPickersToolbarText-toolbarBtnSelected': selected,
      })}
      {...other}
    >
      {label}
    </span>
  )
}

export default ToolbarText
